module.exports = __webpack_public_path__ + "static/media/location.8c6067f6.svg";